import request from '@/utils/request'

let UnitApi = {
  toAddUnit(data, errorback) {
    return request._get('/shop/unit.unit/add', data, errorback);
  },
  /*添加分局*/
  addUnit(data, errorback) {
    return request._post('/shop/unit.unit/add', data, errorback);
  },

  /*分局详情*/
  unitDetail(data, errorback) {
    return request._get('/shop/unit.unit/edit', data, errorback);
  },

  /*分局编辑*/
  editUnit(data, errorback) {
    return request._post('/shop/unit.unit/edit', data, errorback);
  },

  /*删除分局*/
  deleteUnit(data, errorback) {
    return request._post('/shop/unit.unit/delete', data, errorback);
  },

  /*分局列表*/
  unitList(data, errorback) {
    return request._post('/shop/unit.unit/index', data, errorback);
  },

  groupList(data, errorback) {
    return request._post('/shop/unit.group/index', data, errorback);
  },
  toAddGroup(data, errorback) {
    return request._get('/shop/unit.group/add', data, errorback);
  },
  /*添加分局队伍*/
  addGroup(data, errorback) {
    return request._post('/shop/unit.group/add', data, errorback);
  },

  /*分局队伍详情*/
  groupDetail(data, errorback) {
    return request._get('/shop/unit.group/edit', data, errorback);
  },

  /*分局队伍编辑*/
  editGroup(data, errorback) {
    return request._post('/shop/unit.group/edit', data, errorback);
  },

  /*删除分局队伍*/
  deleteGroup(data, errorback) {
    return request._post('/shop/unit.group/delete', data, errorback);
  },
  /*用户列表*/
  userlist(data, errorback) {
      return request._post('/shop/unit.group/userlist', data, errorback);
  },
}

export default UnitApi;



// WEBPACK FOOTER //
// ./src/api/unit.js